<template>
    <!-- main start  -->
    <div id="main">
        <!-- Main Header -->
        <MainHeader />

        <!-- Top Header -->
        <div class="top-header top-header-half">
            <div class="page-subtitle">
                <span>{{ categoryName }}</span>
            </div>
            <router-link to="/contact" class="single-page-fixed-row-link">
                <i class="fal fa-envelope"></i> <span>Get In Touch</span>
            </router-link>
        </div>
        <!-- top-header end-->

        <!-- wrapper  -->
        <div id="wrapper">
            <!-- content-holder  -->
            <div class="content-holder" data-pagetitle="Projects">
                <!-- Navigation -->
                <Navigation />

                <!-- content-->
                <div class="content">
                    <!--column-wrap-->
                    <div class="column-wrap">
                        <!--column-wrap-container -->
                        <div class="column-wrap-container white-bg fl-wrap">
                            <div class="col-wc_dec"></div>

                            <!-- Loading State -->
                            <section v-if="loading" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>Loading...</h2>
                                    </div>
                                </div>
                            </section>

                            <!-- Error State -->
                            <section v-else-if="error" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>{{ error }}</h2>
                                        <div class="sec-title_dec"></div>
                                    </div>
                                    <div class="column-wrapper_text fl-wrap">
                                        <router-link to="/" class="btn float-btn">
                                            <span>Go to Homepage</span>
                                        </router-link>
                                    </div>
                                </div>
                            </section>

                            <!-- Category header + projects grid -->
                            <section v-else id="sec1" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>{{ categoryName }}</h2>
                                        <div class="sec-title_dec"></div>
                                    </div>

                                    <div v-if="projects.length === 0" class="column-wrapper_text fl-wrap">
                                        <p>No projects have been added to this category yet.</p>
                                    </div>

                                    <div v-else class="row">
                                        <div class="col-md-4" v-for="project in projects" :key="project.id">
                                            <router-link
                                                :to="`/projects/${categorySlug}/${project.slug}`"
                                                class="portfolio-item fl-wrap"
                                            >
                                                <div class="portfolio-image fl-wrap" style="height:220px; overflow:hidden; margin-bottom:15px;">
                                                    <img
                                                        v-if="project.featured_image"
                                                        :src="project.featured_image"
                                                        :alt="project.title"
                                                        class="respimg"
                                                        style="width:100%; height:100%; object-fit:cover;"
                                                    >
                                                </div>
                                                <h3>{{ project.title }}</h3>
                                                <p v-if="project.description">{{ project.description }}</p>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-number">
                                    <span>0</span>1<strong>.</strong>
                                </div>
                            </section>
                        </div>
                        <!--column-wrap-container end-->
                    </div>
                    <!--column-wrap end-->
                    <div class="limit-box fl-wrap"></div>
                </div>
                <!-- content end  -->

                <!-- Footer -->
                <AppFooter />
            </div>
            <!-- content-holder end -->
        </div>
        <!-- wrapper end -->
    </div>
    <!-- Main end -->
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Navigation from '@/components/Navigation.vue'
import AppFooter from '@/components/Common/AppFooter.vue'

export default {
    name: 'ProjectCategory',
    components: {
        MainHeader,
        Navigation,
        AppFooter
    },
    data() {
        return {
            projects: [],
            categoryName: '',
            loading: true,
            error: null
        }
    },
    computed: {
        categorySlug() {
            return this.$route.params.categorySlug
        }
    },
    async mounted() {
        await this.loadProjects()
    },
    watch: {
        async '$route'() {
            await this.loadProjects()
        }
    },
    methods: {
        async loadProjects() {
            this.loading = true
            this.error = null

            try {
                const response = await this.$api.get(`public/content/${this.categorySlug}`)
                this.projects = (response.data && response.data.data) || []
                this.categoryName = this.projects.length && this.projects[0].content_type
                    ? this.projects[0].content_type.name
                    : this.categorySlug.replace(/-/g, ' ')

                document.title = this.categoryName
            } catch (error) {
                console.error('Failed to load project category:', error)
                this.error = 'Category not found'
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
